import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CurrencyContext = createContext(null);
export const GBP_RATE = 0.79;

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    const saved = localStorage.getItem("onecare_currency");
    if (saved === "USD" || saved === "GBP") return saved;
    return /en-gb/i.test(navigator.language || "") ? "GBP" : "USD";
  });

  useEffect(() => {
    localStorage.setItem("onecare_currency", currency);
  }, [currency]);

  const format = useMemo(
    () => (usd) =>
      currency === "GBP"
        ? `£${Math.round(usd * GBP_RATE).toLocaleString("en-GB")}`
        : `$${Number(usd).toLocaleString("en-US")}`,
    [currency],
  );

  const toggle = () => setCurrency((c) => (c === "USD" ? "GBP" : "USD"));

  const value = useMemo(() => ({ currency, toggle, format }), [currency, format]);
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
};

export const useCurrency = () => useContext(CurrencyContext);
